import { TemplateElement, html, defineElement } from '@webtides/element-js';

export default class ShareElement extends TemplateElement {
    connected() {
        super.connected();
        this.currentUrl = this.getCurrentUrl();
    }

    properties() {
        return {
            open: false,
            modalId: 0,
            editMode: false,
            titel: '',
            text: '',
            copyText: '',
            copyButton: '',
            facebook: true,
            twitter: true,
            linkedin: true,
            mail: true,
            currentUrl: '',
            shareUrl: '',
            iconSize: 'small',
            hoverTitle: '',
        };
    }

    watch() {
        return {
            shareUrl: (newValue, oldValue) => {
                this.currentUrl = this.getCurrentUrl();
            },
        };
    }

    getCurrentUrl() {
        if (this.shareUrl !== '') {
            return this.shareUrl;
        }

        const canonical = document.querySelector("link[rel='canonical']");
        if (canonical) {
            return canonical.href;
        }
        return window.location.href;
    }

    detectMobile() {
        return window.innerWidth <= 800 && window.innerHeight <= 600;
    }

    events() {
        return {
            '[ref=shareBtn]': {
                click: () => {
                    if (this.editMode) {
                        return;
                    }
                    if (navigator.share && this.detectMobile()) {
                        navigator.share({
                            title: 'Website Share',
                            url: this.currentUrl,
                        });
                    } else {
                        this.open();
                    }
                },
            },
            '[ref="shareCloseBtn"]': {
                click: () => {
                    this.close();
                },
            },
            '[data-copy]': {
                click: () => {
                    const copyText = this.$refs.copy;
                    copyText.select();
                    copyText.setSelectionRange(0, 99999);
                    // navigator.navigator does not work at localhost or HTTP, because of unsecure content;
                    if (navigator.clipboard) {
                        navigator.clipboard.writeText(copyText.value);
                    }
                },
            },
        };
    }

    open() {
        this.$refs.shareModal?.open();
    }

    close() {
        this.$refs.shareModal?.close();
    }

    template() {
        return html`
            <div ref="shareBtn" class="z-10 flex cursor-pointer justify-end hover:text-brand-700">
                <div class="leading-3" title="${this.hoverTitle}">
                    <svg-use name="icons-share" class="${this.iconSize === 'big' ? 'h-8 w-8' : 'h-4 w-4'}"></svg-use>
                </div>
            </div>

            <modal-element ref="shareModal" disable-footer="true" modal-id="${this.modalId}" cloak="true">
                <div slot="title" class="h6 text-black">${this.titel}</div>
                <div slot="close" ref="shareCloseBtn" class="flex">
                    <svg-use name="icons-material-outline-close" class="h-6 w-6 text-grey-900"></svg-use>
                </div>

                <div slot="content">
                    <div class="pb-4 text-base text-grey-700">${this.text}</div>
                    <div class="flex border-b border-grey-500 border-opacity-40 pb-6 text-brand-500">
                        ${this.facebook === false
                            ? ''
                            : html`
                                  <div class="facebook flex h-full p-4 hover:bg-grey-100">
                                      <a
                                          class="flex"
                                          target="_blank"
                                          href="https://www.facebook.com/share.php?u=${this.currentUrl}">
                                          <svg-use name="icons-social-facebook" class="h-8 w-8"></svg-use>
                                      </a>
                                  </div>
                              `}
                        ${this.twitter === false
                            ? ''
                            : html`
                                  <div class="twitter flex h-full p-4 hover:bg-grey-100">
                                      <a
                                          class="flex"
                                          target="_blank"
                                          href="https://twitter.com/share?url=${this.currentUrl}">
                                          <svg-use name="icons-social-twitter" class="h-8 w-8"></svg-use>
                                      </a>
                                  </div>
                              `}
                        ${this.linkedin === false
                            ? ''
                            : html`
                                  <div class="linkedin flex h-full p-4 hover:bg-grey-100">
                                      <a
                                          class="flex"
                                          target="_blank"
                                          href="https://www.linkedin.com/shareArticle?mini=true&url=${this.currentUrl}">
                                          <svg-use name="icons-social-linkedin" class="h-8 w-8"></svg-use>
                                      </a>
                                  </div>
                              `}
                        ${this.mail === false
                            ? ''
                            : html`
                                  <div class="mail flex h-full p-4 hover:bg-grey-100">
                                      <a href="mailto:?subject=${document.title}&body=${this.currentUrl}">
                                          <svg-use name="icons-material-outline-email" class="h-8 w-8"></svg-use>
                                      </a>
                                  </div>
                              `}
                    </div>
                    <div class="pb-2 pt-4 text-base text-grey-700">${this.copyText}</div>
                    <div
                        class="flex flex-row items-center justify-between gap-2 rounded-sm border-2 border-grey-400 p-2 text-base text-grey-700">
                        <input ref="copy" type="text" value="${this.currentUrl}" class="w-full outline-none" />
                        <button
                            class="whitespace-nowrap rounded bg-brand-500 px-6 py-2 font-medium text-white"
                            data-copy>
                            ${this.copyButton}
                        </button>
                    </div>
                </div>
            </modal-element>
        `;
    }
}

export function define() {
    defineElement('share-element', ShareElement);
}
